export const en = {
    'cpa-sign': 'Estimated based on CPA',
    'many-days-clicks-title': 'Estimated clicks over {value} days',
    'many-days-cost-title': 'Estimated spending over {value} days',
    'many-days-ctr-title': 'Estimated conversions over {value} days',
    'one-day-clicks-title': 'Estimated clicks over {value} day',
    'one-day-cost-title': 'Estimated spending over {value} day',
    'one-day-ctr-title': 'Estimated conversions over {value} day',
    'roi-sign': 'Estimated based on ROI',
    'some-days-clicks-title': 'Estimated clicks over {value} days',
    'some-days-cost-title': 'Estimated spending over {value} days',
    'some-days-ctr-title': 'Estimated conversions over {value} days'
};
